module.exports = __webpack_public_path__ + "img/british-columbia.cff2a989.png";